import React, {Component, Fragment} from 'react';

class AlertThanks extends Component {
  render() {
    const {actionBtn} = this.props;
    return (
      <Fragment>
        <div className="overflow-popup"></div>
        <div className="alert-common alert-common--thanks">
          <h6 className="alert-common__subtitle">Wichtige Mitteilung!</h6>
          <h4 className="alert-common__title">Ihr Auftrag befindet sich in Bearbeitung, unser Kundenberater meldet sich schnellstmöglich bei Ihnen. Vielen Dank!</h4>
          <button className="alert-common__btn alert-common__btn--cancel" onClick={actionBtn}>Zu Startseite wechseln</button>
        </div>
      </Fragment>
    );
  }
}

export default AlertThanks;


// WEBPACK FOOTER //
// ./src/components/Alerts/AlertThanks.js